var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ImageZoom",class:{'with-border': _vm.border}},[_c('img',{ref:"img",attrs:{"src":_vm.imageURL,"alt":_vm.alt,"width":_vm.width,"title":_vm.title}})])
}
var staticRenderFns = []

export { render, staticRenderFns }